import { Component, inject } from '@angular/core';

import { AuthService } from './_services/auth.service';

import { RouterLink } from '@angular/router';



@Component({
    selector: 'app-register', templateUrl: 'register.component.html',
    imports: [RouterLink]
})
export class RegisterComponent {
    authService = inject(AuthService);
}

